// `scriptctl review` sits apart from both the script verbs and the workflow
// commands: it is the one command that dispatches an agent.
import { Command } from "commander";

import { commandReview } from "../usecases/script/review.js";
import { dispatch, type RunState, withScriptOpts } from "./registry.js";

export function registerReviewCommand(program: Command, state: RunState): void {
  withScriptOpts(program.command("review"), "write")
    .description("派发 agent 审核剧本：给 -s 就按原视频拉片核对，不给就纯剧本审核")
    .option("-s, --source-path <path>", "原视频文件或每集一个视频的目录")
    .option(
      "--video <path>",
      "第 N 集的视频；按集顺序重复传，覆盖 -s 的目录排序",
      (value: string, previous: string[]) => [...previous, value],
      [] as string[],
    )
    .option("--episodes <list>", "只审这些集，逗号分隔（默认全剧）")
    .option("--concurrency <n>", "同时在飞的集数", Number)
    .option("--episode-timeout-ms <ms>", "单集超时；到点收尾并保留已记录的结论", Number)
    .option("--max-steps <n>", "单集最多几步工具调用", Number)
    .option("--media-budget <n>", "单集最多几次视频核对", Number)
    .option("--no-converge", "跳过全剧收敛阶段")
    .option("--model <profile>", "覆盖 LLM profile（默认 review-agent）")
    .option("--llm-config <path>", "LLM configuration file")
    .option("--check", "只检查模型与 agent 是否就绪，不审核")
    .action(dispatch(commandReview, state));
}
